export default '/@lang/about'
